module.exports = __webpack_public_path__ + "static/media/icon-laposte.7d0e7f08.svg";